import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import styles from "./Button.module.css";

const VARIANT_CLASS: Record<string, string> = {
  primary: styles.primary,
  secondary: styles.secondary,
  outline: styles.outline,
  ghost: styles.ghost,
  destructive: styles.destructive,
  destructiveSubtle: styles.destructiveSubtle,
  link: styles.link,
};

const SIZE_CLASS: Record<string, string> = {
  default: styles.sizeDefault,
  xs: styles.sizeXs,
  sm: styles.sizeSm,
  md: styles.sizeMd,
  lg: styles.sizeLg,
  icon: styles.sizeIcon,
};

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'destructive' | 'destructiveSubtle' | 'link';
  size?: 'default' | 'xs' | 'sm' | 'md' | 'lg' | 'icon';
  asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "primary", size = "md", asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    const cls = [
      styles.button,
      VARIANT_CLASS[variant] ?? styles.primary,
      SIZE_CLASS[size] ?? styles.sizeMd,
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return <Comp className={cls} ref={ref} {...props} />;
  }
);
Button.displayName = "Button";

export { Button };
